import React from 'react';
import { BrandAlphaCard } from './brandAlphaCard';

/*
    React function to display pre-sorted columns of manufactuers
    alpha-numeric grouping per first character in Brand name ('3','A','B'...)
*/
export const BrandAlphaCardList = (props) => {
    var colBreak = 12 / props.numCols;
    return (
        <div className={'col-md-' + colBreak}>
            {props.data.map((card, index) => <BrandAlphaCard key={index} data={card} />)}
        </div>
    );
};